module.exports = __webpack_public_path__ + "img/payment-cash-illustration.d8a15f5d.svg";